
define(
    'jsx!components/ideas-lab/ideas-lab-detail',[
   	"jquery",
	"underscore",
	"backbone",
    "react",
    "jsx!components/tooltip",
    "shared/browser-detect",
    ], 
    function ($, _, Backbone, React, Tooltip, BrowserDetect){
        return React.createClass({
            displayName: "IdeasLabDetail",
            getDefaultProps: function ()
            {   
                return {
                    "buncee": "",
                    "onCreateClick": function () {},
                    "onBookmarkedClick": function () {},
                    "favorites": [],
                    "onClick": function () {},
                    "openFrom": "",
                    "trackIdea": function () {},
                };
            },
            onViewThisClick: function () 
            {
                var imageRegex = /\.(jpeg|jpg|gif|png|svg)($|(\?))/i;
                this.props.trackIdea(this.props.buncee.id, "view");
                if (this.props.buncee.entity_url.indexOf("bunceeboard") > -1 || this.props.buncee.entity_url.match(imageRegex)) {
                    var win = window.open(this.props.buncee.entity_url, '_blank');
                    win.focus();
                    return;
                }

                if (!this.props.buncee.content.hasOwnProperty("templateURL")) { 
                    originalDomain = this.props.buncee.entity_url.split("//");
                    originalDomain = originalDomain[1].split(".");
                    originalDomain = originalDomain[0];

                    bunceeGuid = this.props.buncee.entity_url.split("/");
                    bunceeGuid = bunceeGuid[bunceeGuid.length - 1];

                    var globalURL = "/buncee/" +bunceeGuid + "?client=" + originalDomain;
                    var win = window.open(globalURL, '_blank');
                    win.focus();
                } else {
                    var win = window.open(this.props.buncee.content.templateURL, '_blank');
                    win.focus();
                }

            },
            onUpgradeClick: function ()
            {
                window.location = "/links/billing";
            },
            isViewableIdea: function()
            {
                // No templateURL means that the buncee is viewable only
                if (!(this.props.buncee.content.hasOwnProperty("templateURL"))) {
                    return true;
                }
                return false;
            },
            renderButtons: function ()
            {
                var self = this;
                var favoriteClassName =  _.find(self.props.favorites, function (favorite) {return favorite.asset_guid === self.props.buncee.id}) ?
                "favorite icons8-bookmark-active" : "favorite icons8-bookmark-inactive";
                var buttonElement = null;
                var bookmarkElement = null;

                if (this.isViewableIdea() || (BrowserDetect.isMobileStrict())) {
                    buttonElement = React.createElement("div", {className: "content-detail-button view-this", onClick: this.onViewThisClick}, "View this");
                    bookmarkElement = React.createElement("div", {className: favoriteClassName, onClick: function()  {self.props.onBookmarkedClick(self.props.buncee.id)}});
                } else if (window.appData.user) {
                    buttonElement = (React.createElement("div", {className: "content-detail-button create-this", onClick:  function()  {this.props.onCreateThisClick(self.props.buncee)}.bind(this)}, 
                        "Create this"
                    ));
                    if (window.appData.user.data.type === "generic-free" && this.props.buncee.is_premium) {
                        buttonElement = (React.createElement(Tooltip, {text: "Upgrade account to use!", direction: "up"}, 
                                React.createElement("div", {className: "content-detail-button create-this disable", onClick: this.onUpgradeClick}, 
                                    "Create This"
                                )
                            ));
                    }
                } else {
                    buttonElement = (React.createElement(Tooltip, {text: "Log in to Create This!", direction: "up"}, 
                            React.createElement("div", {className: "content-detail-button create-this disable", onClick:  function()  {this.props.onCreateThisClick(self.props.buncee)}.bind(this)}, 
                                "Create this"
                            )
                        ));
                }

                if ((BrowserDetect.isMobileStrict())) {
                    bookmarkElement = null;
                } else if (window.appData.user) {
                    bookmarkElement = (React.createElement("div", {className: favoriteClassName, onClick: function()  {self.props.onBookmarkedClick(self.props.buncee.id)}}));
                } else {
                    bookmarkElement = (React.createElement(Tooltip, {text: "Log in to Bookmark!", direction: "up"}, 
                            React.createElement("div", {className: favoriteClassName + " disable", onClick:  function()  {this.props.onBookmarkedClick()}.bind(this)})
                        ));
                }
                
                return (
                    React.createElement("div", {className: "content-detail-button-container"}, 
                         buttonElement, 
                         bookmarkElement
                    )
                );

            },
            renderCategories: function() 
            {
                var self = this;
                var categories = _.map(this.props.buncee.categories, function (category, index) {
                    if (index + 1 === self.props.buncee.categories.length) {
                        return category.name.trim();
                    } else { 
                        return category.name.trim().concat(" | ");
                    }
                });
                return categories;
            },
            renderDescriptionClassName: function() 
            {
                var descriptClassName = "content-detail-description";
                if (this.props.openFrom === "modal") {
                    descriptClassName += " scroll";
                    if (document.getElementsByClassName("content-detail-description")[0].scrollHeight > 80) {
                        descriptClassName += " custom-scroll"
                    }   
                }
                return descriptClassName;
            },
            render: function ()
            {   
                var self = this;
                return (    
                    React.createElement("div", {className: "content-detail-text"}, 
                        React.createElement("div", {onClick: function () { self.props.onClick(self.props.buncee.id); }}, 
                            React.createElement("div", {className: "content-detail-topic"}, 
                                 this.renderCategories() 
                            ), 
                            React.createElement("div", {className: "content-detail-title"}, 
                                this.props.buncee.content.title
                            ), 
                            React.createElement("div", {
                                className: this.renderDescriptionClassName(), 
                                id: "content-descript", 
                                dangerouslySetInnerHTML: {__html: this.props.buncee.content.description}}
                            ), 
                             this.props.buncee.content.submittedBy ? 
                                React.createElement("div", {
                                    className: "content-detail-owner", 
                                    dangerouslySetInnerHTML: {__html: "Idea submitted by: " + this.props.buncee.content.submittedBy}}
                                ) : null
                            
                        ), 
                        this.renderButtons()
                    )
                );
            }
        });
    }
);
